import { Form, Input, Select } from '@arco-design/web-react';

import type { BareMetalNodesPaths } from '../types';

const FormItem = Form.Item;

interface HiddenNodeFieldsProps {
  paths: BareMetalNodesPaths;
}

/** gpuName / imageTags 隐藏字段，供表单提交与镜像筛选使用 */
export function HiddenNodeFields({ paths }: HiddenNodeFieldsProps) {
  return (
    <>
      <FormItem field={paths.gpuName} hidden>
        <Input />
      </FormItem>
      <FormItem field={paths.imageTags} hidden>
        <Select showSearch mode="multiple" />
      </FormItem>
    </>
  );
}
